// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { useNotifications as _useNotifications } from "@/use/useNotifications";
import { ToastNotificationCtrl } from "@shared/types/localTypes/toastNotifications.ts";
export const useNotifications: ToastNotificationCtrl = _useNotifications;
